import User from '@/models/User';

export const globalMixin = {
  computed: {
    $currentUser() {
      return User.query().first();
    }
  }
};
